<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      d="M16.0002 16.6667C16.3684 16.6667 16.6668 16.3683 16.6668 16.0001C16.6668 15.6319 16.3684 15.3334 16.0002 15.3334C15.632 15.3334 15.3335 15.6319 15.3335 16.0001C15.3335 16.3683 15.632 16.6667 16.0002 16.6667Z"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16.0002 12.0001C16.3684 12.0001 16.6668 11.7016 16.6668 11.3334C16.6668 10.9652 16.3684 10.6667 16.0002 10.6667C15.632 10.6667 15.3335 10.9652 15.3335 11.3334C15.3335 11.7016 15.632 12.0001 16.0002 12.0001Z"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16.0002 21.3334C16.3684 21.3334 16.6668 21.0349 16.6668 20.6667C16.6668 20.2986 16.3684 20.0001 16.0002 20.0001C15.632 20.0001 15.3335 20.2986 15.3335 20.6667C15.3335 21.0349 15.632 21.3334 16.0002 21.3334Z"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup>
defineProps({
  color: {
    type: String,
    default: "#A4A7AE",
  },
});
</script>
